<template>
    <SideFormSection>
        <template #title>Booking Form Settings</template>
        <template #rawContent>
            <Card
                title="Booking Form Settings"
                iconName="company"
            >
                <template #content>
                    <ApiForm
                        :url="RoutePathAppEnum.Company_Update_Info"
                        method="POST"
                        ref="apiFormRef"
                        :key="formKey"
                    >
                        <div class="space-y-2">
                            <CompanyInformationForm
                                :company="localCompany"
                                :errors="
                                    apiFormRef?.response?.getErrors() ??
                                    new ApiFormErrors({})
                                "
                            >
                                <template #extraFields>
                                    <CompanyBookingFormSettingsForm
                                        :company="localCompany"
                                        :errors="
                                            apiFormRef?.response?.getErrors() ??
                                            new ApiFormErrors({})
                                        "
                                    />
                                </template>
                            </CompanyInformationForm>
                        </div>
                    </ApiForm>
                </template>
                <template #actions>
                    <div class="flex gap-2">
                        <Button
                            as="a"
                            :href="
                                urlFactory.makeCompanyBookingFormUrl(
                                    company.slug,
                                )
                            "
                            target="_blank"
                            iconName="external-link"
                            iconClass="w3.5 h-3.5"
                            color="light"
                        >
                            View
                        </Button>
                        <Button
                            @click="submit()"
                            :loading="apiFormRef?.loading.valueOf()"
                            iconName="save"
                            color="dark"
                        >
                            Save
                        </Button>
                    </div>
                </template>
            </Card>
        </template>
    </SideFormSection>
</template>

<script setup lang="ts">
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import { ref, type PropType } from 'vue'
    import SideFormSection from '@/Shared/Component/SideFormSection.vue'
    import Button from '@/Shared/Component/Button.vue'
    import Card from '@/Shared/Component/Card.vue'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import Company from '@/App/Company/Entity/Company'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import { ResponseJsonKeyEnum } from '@/Shared/AutoGenerated/Main'
    import CompanyInformationForm from '@/App/Company/Component/CompanyInformationForm.vue'
    import ApiFormResponseType from '@/Shared/Component/Forms/ApiFormResponseType'
    import ApiFormErrors from '@/Shared/Component/Forms/ApiFormErrors'
    import CompanyBookingFormSettingsForm from '@/App/Company/Component/CompanyBookingFormSettingsForm.vue'
    import { RoutePathAppEnum } from '@/Shared/AutoGenerated/RoutePathEnum'

    const props = defineProps({
        company: {
            type: Object as PropType<Company>,
            required: true,
        },
    })

    const localCompany = ref(props.company)
    const formKey = ref<number>(0)
    const apiFormRef = ref<ApiFormRefType>(null)

    const submit = () => {
        apiFormRef.value?.submit()?.then((response: ApiFormResponseType) => {
            formKey.value += 1
            localCompany.value = response.getHydratedCompany(
                ResponseJsonKeyEnum.App_Company_UpdateInfo_CompanyData,
            )
        })
    }
    const urlFactory = new UrlFactory()
</script>
